import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { PageContainer } from '@/components/shared/page-container';

export const PageSkeleton = () => {
  return (
    <PageContainer>
      <Grid container spacing={3} data-testid="page-loading">
        <Grid size={12}>
          <Typography variant="h3" sx={{ width: '100%' }}>
            <Skeleton variant="rounded" />
          </Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <Typography>
            <Skeleton variant="rounded" />
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography>
            <Skeleton variant="rounded" />
          </Typography>
        </Grid>
      </Grid>
    </PageContainer>
  );
};
